/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/pages/auth/AuthPage`, `src/pages/home/HomePage`).
 */

import { LayoutContextProvider } from '_metronic'
import Layout from '_metronic/layout/Layout'
import { ZariProvider } from '_zari/context'
import { AdminProvider } from 'contexts/AdminContext'
import { PeriodoProvider } from 'contexts/PeriodoContext'
import { shallowEqual, useSelector } from 'react-redux'
import { Redirect, Route, Switch, withRouter } from 'react-router-dom'

import ActivosFijosPage from 'pages/activosFijos'
import ActivosFijosBajasPage from 'pages/activosFijosBajas'
import ActivosFijosInventariosPage from 'pages/activosFijosInventarios'
import AsientosContablesPage from 'pages/asientosContables'
import BloqueosPeriodosPage from 'pages/bloqueosPeriodos'
import BackgroundJobsPage from 'pages/backgroundJobs'
import CajaChicaPage from 'pages/cajaChica'
import CompaniasPage from 'pages/companias'
import ComputerPage from 'pages/computer'
import ContabilidadCostosPage from 'pages/contabilidad-costos'
import EstadoFinancieroPage from 'pages/estadosFinancieros'
import EstructuraBalancePage from 'pages/estructuraBalance'
import FondosFijosPage from 'pages/fondosFijos'
import GlosasPage from 'pages/glosas'
import LibrosElectronicosPage from 'pages/librosElectronicos'
import MayorizacionPage from 'pages/mayorizacion'
import PlanContablePage from 'pages/planContable'
import PlantillasContabilidadPage from 'pages/plantillasContabilidad'
import PlantillasGeneralesContabilidadPage from 'pages/plantillasGeneralesContabilidad'
import PresupuestosPage from 'pages/presupuestos'
import PresupuestosAsignacionPage from 'pages/presupuestos-asignacion'
import ProyectosPage from 'pages/proyectos'
import RolesPage from 'pages/roles'
import SelfPage from 'pages/self'
import SociosPage from 'pages/socios'
import TablasComunesPage from 'pages/tablasComunes'
import UsuariosPage from 'pages/usuarios'

import AuthPage from 'pages/auth/AuthPage'
import LogoutPage from 'pages/auth/Logout'
import ErrorsPage from 'pages/errors/ErrorsPage'
import HomePage from 'pages/home'
import PresupuestosNuevoPage from 'pages/presupuestosNuevo'

export const Routes = withRouter(() => {
  const { menuConfig } = useSelector(({ auth, _, builder: { menuConfig } }) => {
    return {
      menuConfig
    }
  }, shallowEqual)

  const isAuthorized = !!window.localStorage.getItem('token')

  return (
    <LayoutContextProvider menuConfig={menuConfig}>
      <ZariProvider>
        <Switch>
          {!isAuthorized ? (
            /* Render auth page when user at `/auth` and not authorized. */
            <AuthPage />
          ) : (
            /* Otherwise redirect to root page (`/`) */
            <Redirect from='/auth' to='/' />
          )}

          <Route path='/error' component={ErrorsPage} />
          <Route path='/logout' component={LogoutPage} />

          {!isAuthorized ? (
            /* Redirect to `/auth` when user is not authorized */
            <Redirect to='/auth/login' />
          ) : (
            <AdminProvider>
              <PeriodoProvider>
                <Layout>
                  <ActivosFijosPage />
                  <ActivosFijosBajasPage />
                  <ActivosFijosInventariosPage />
                  <AsientosContablesPage />
                  <BackgroundJobsPage />
                  <BloqueosPeriodosPage />
                  <CajaChicaPage />
                  <CompaniasPage />
                  <ComputerPage />
                  <ContabilidadCostosPage />
                  <EstadoFinancieroPage />
                  <EstructuraBalancePage />
                  <FondosFijosPage />
                  <GlosasPage />
                  <LibrosElectronicosPage />
                  <MayorizacionPage />
                  <PlanContablePage />
                  <PlantillasContabilidadPage />
                  <PlantillasGeneralesContabilidadPage />
                  <SelfPage />
                  <TablasComunesPage />
                  <UsuariosPage />
                  <SociosPage />
                  <PresupuestosPage />
                  <PresupuestosNuevoPage />
                  <PresupuestosAsignacionPage />
                  <ProyectosPage />
                  <RolesPage />
                  <Switch>
                    <Route path='/' component={HomePage} />
                    <Redirect to='/error/error-v1' />
                  </Switch>
                </Layout>
              </PeriodoProvider>
            </AdminProvider>
          )}
        </Switch>
      </ZariProvider>
    </LayoutContextProvider>
  )
})
